import moment from 'moment';
import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  Form,
  InputGroup,
  Row,
} from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useSelector } from 'react-redux';
import { getRequest, postRequest } from '../../../utils/axiosRequests';
import {
  ageConvertToDateTime,
  defaultGeneralData,
  separateDateTime,
} from '../../../utils/helpers';
import GeneralExaminationBtn from '../partials/generalExaminationBtn';
import SearchAreaAsyncAppointment from './searchAreaAsyncAppointment';

const BasicPatientForAppointment = ({
  patientInfo,
  setPatientInfo,
  selectSearchResult,
  phoneNumber,
  setPhoneNumber,
  appointmentInfo,
  isEdit,
  setAppointmentDateTime,
  visitType,
  setVisitType,
  setVisitationFee,
  errors,
  patientType,
  setPatientType,
  selectedChiefComplains,
  setSelectedChiefComplains,
  selectedOnExamination,
  setSelectedOnExamination,
}) => {
  let generalExaminations =
    selectedOnExamination?.generalExaminations || defaultGeneralData();
  const [fieldName, setFieldName] = useState('');
  const [btnInputArray, setBtnInputArray] = useState([]);
  const [isGeneralExaminationBtn, setIsGeneralExaminationBtn] = useState(false);
  const [ageOrDob, setAgeOrDob] = useState(false);
  const [birthDate, setBirthDate] = useState('');
  const [dob, setDob] = useState({
    years: '',
    months: '',
    days: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const [searchResultArr, setSearchResultArr] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState({});
  const [phoneNumberTemp, setPhoneNumberTemp] = useState(
    patientInfo?.phoneNumber || '',
  );
  const [appointmentSchedule, setAppointmentSchedule] = useState('');
  const userInfo = useSelector((state) => state.authReducer.data);
  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );
  //for new task
  const [chiefComplains, setChiefComplains] = useState([]);
  const [closeFunction, setCloseFunction] = useState(false);
  const [chiefComplainsInSearch, setChiefComplainsInSearch] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const getErrorMessage = (inputName) => {
    return errors[inputName] ? errors[inputName] : '';
  };

  useEffect(() => {
    if (patientInfo) {
      setDob(separateDateTime(patientInfo?.dob));
      setBirthDate(
        moment(patientInfo?.dob).add(1, 'days').format('YYYY-MM-DD'),
      );
      if (!patientInfo?.gender) {
        patientInfo['gender'] = 'male';
      }

      if (patientInfo?.phoneNumber) {
        handleOnInputChange(patientInfo?.phoneNumber);
      }
      setSelectedPatient({
        id: patientInfo?.id,
        phoneNumber: patientInfo?.phoneNumber,
      });
      setPhoneNumberTemp(patientInfo?.phoneNumber);
      const dateTime = appointmentInfo?.appointmentDateTime
        ? moment
            .utc(appointmentInfo.appointmentDateTime)
            .local()
            .format('YYYY-MM-DD HH:mm')
        : moment().format('YYYY-MM-DD HH:mm');
      setAppointmentDateTime(dateTime);
      setAppointmentSchedule(dateTime);
      // setAppointmentDateTime(
      //   moment
      //     .utc(appointmentInfo.appointmentDateTime)
      //     .local()
      //     .format('YYYY-MM-DD HH:mm'),
      // );
      setVisitationFee(
        appointmentInfo?.paymentDetails?.amount
          ? appointmentInfo?.paymentDetails?.amount
          : '',
      );
    }
  }, [phoneNumberTemp]);

  const handleAge = (fieldName, val) => {
    if (fieldName === 'months' && val >= 12) {
      alert('Months must be less than 12');
      return false;
    }
    if (fieldName === 'days') {
      let daysOfMonth = dob?.months
        ? moment().month(dob?.months).daysInMonth()
        : moment().daysInMonth();
      if (val > daysOfMonth) {
        alert(`Days must be less than ${daysOfMonth}`);
        return false;
      }
    }
    if (fieldName === 'dob') {
      const dob = separateDateTime(val);
      setDob({ ...dob });
      setPatientInfo({ ...patientInfo, dob: val });
    } else {
      const dobData = { ...dob, [fieldName]: val };
      setDob({ ...dobData });
      const convertedDateTime = ageConvertToDateTime(dobData);
      setPatientInfo({ ...patientInfo, dob: convertedDateTime });
    }
  };

  const getPatientSearchUrl = (val) => {
    if (activeDoctor) {
      return `patients/patient-for-appointment?searchKey=${val}&doctorId=${activeDoctor.id}`;
      // return `patients?phoneNumber=${val}`;
    } else {
      return `patients/patient-for-appointment?searchKey=${val}`;
    }
  };

  const typeaheadRef = useRef(null);
  const filterBy = () => true;
  const handleOnInputChange = (val) => {
    setIsLoading(true);
    const url = getPatientSearchUrl(val);
    setPhoneNumber(val);
    setPatientInfo({ ...patientInfo, phoneNumber: val });

    getRequest(url)
      .then((data) => {
        //for removing same patient using name and phoneNumber
        const unique = [];
        const seen = new Set();
        for (const item of data) {
          const key = `${item.name}-${item.phoneNumber}`;
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(item);
          }
        }
        //end of remoging same patient
        setSearchResultArr(unique);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleType = (val) => {
    setAgeOrDob(val);
    if (!val) {
      setDob(separateDateTime(patientInfo.dob));
    } else {
    }
  };

  const selectOption = (selectedData) => {
    const phone = selectedData?.[0]?.phoneNumber;
    if (phone) {
      setPhoneNumber(phone);
      setPhoneNumberTemp(phone);
      setPatientInfo({ ...patientInfo, phoneNumber: phone });
    }
    selectSearchResult(selectedData);
    setPatientType('old');
  };

  const handleOnInputChangeChiefComplain = async (searchKey) => {
    setIsLoading(true);
    if (searchKey) {
      setChiefComplainsInSearch([]);
      let url = `chief-complains?name=${encodeURIComponent(searchKey)}`;
      if (userInfo.userType === 'assistant') {
        url = `chief-complains?name=${encodeURIComponent(searchKey)}&doctorId=${
          activeDoctor.id
        }`;
      }

      setSearchQuery(searchKey);

      await getRequest(url)
        .then((data) => {
          setChiefComplainsInSearch(data?.data);
          setIsLoading(false);
        })
        .catch(console.error);
    }
  };

  const handleSearchOrNew = async (selectedOption) => {
    try {
      const { name: selectedData, customOption: isNewOption } =
        selectedOption[0];
      if (isNewOption) {
        const data = await postRequest('chief-complains', {
          name: selectedData,
        });
        setChiefComplains([...chiefComplains, data]);
        setSearchQuery('');
        setSelectedChiefComplains([
          ...selectedChiefComplains,
          {
            name: selectedData,
            side: '',
            duration: '',
            unit: 'day(s)',
            note: '',
          },
        ]);
      } else {
        const isExisting = selectedChiefComplains?.some(
          ({ name }) => name?.toLowerCase() === selectedData?.toLowerCase(),
        );
        setSelectedChiefComplains(
          isExisting
            ? selectedChiefComplains?.filter(
                ({ name }) =>
                  name?.toLowerCase() !== selectedData?.toLowerCase(),
              )
            : [
                ...selectedChiefComplains,
                {
                  name: selectedData,
                  side: '',
                  duration: '',
                  unit: 'day(s)',
                  note: '',
                },
              ],
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleBtnInputArray = (field) => {
    setFieldName(field);
    let buttonArray;
    if (field === 'systolic') {
      buttonArray = [
        70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
      ];
    } else if (field === 'diastolic') {
      buttonArray = [40, 50, 60, 70, 80, 90, 100, 110, 120];
    } else if (field === 'pulse') {
      buttonArray = [
        40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
      ];
    } else if (field === 'temperature') {
      buttonArray = [95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    } else if (field === 'weight') {
      buttonArray = [
        40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
        125, 130,
      ];
    } else if (field === 'feet') {
      buttonArray = [3, 4, 5, 6, 7];
    } else if (field === 'inch') {
      buttonArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    } else if (field === 'idealWeight') {
      buttonArray = [40, 45, 50, 55, 60, 65, 70, 75, 80];
    }
    setIsGeneralExaminationBtn(isGeneralExaminationBtn ? false : true);
    setBtnInputArray(buttonArray);
  };

  const handleInput = (fieldName, val) => {
    let updatedGeneralData = { ...generalExaminations };
    setFieldName('');
    if (fieldName === 'bloodGroup') {
      updatedGeneralData[fieldName] =
        updatedGeneralData[fieldName] === val ? '' : val;
    } else if (fieldName === 'systolic' || fieldName === 'diastolic') {
      updatedGeneralData.bloodPressure[fieldName] = val;
    } else if (
      fieldName === 'pulse' ||
      fieldName === 'pulseUnit' ||
      fieldName === 'pulseType'
    ) {
      if (fieldName === 'pulseType') {
        updatedGeneralData.pulseInfo[fieldName] =
          updatedGeneralData.pulseInfo[fieldName] === val ? '' : val;
      } else {
        updatedGeneralData.pulseInfo[fieldName] = val;
      }
    } else if (fieldName === 'temperature' || fieldName === 'temperatureUnit') {
      updatedGeneralData.temperatureInfo[fieldName] = val;
    } else if (fieldName === 'temperatureType') {
      updatedGeneralData.temperatureInfo[fieldName] = updatedGeneralData
        .temperatureInfo[fieldName]
        ? ''
        : val;
    } else if (
      fieldName === 'weight' ||
      fieldName === 'weightUnit' ||
      fieldName === 'weightShowInPrescription'
    ) {
      updatedGeneralData.weightInfo[fieldName] = val;
    } else if (
      fieldName === 'feet' ||
      fieldName === 'inch' ||
      fieldName === 'heightUnit'
    ) {
      updatedGeneralData.heightInfo[fieldName] = val;
    }

    setSelectedOnExamination({
      ...selectedOnExamination,
      generalExaminations: updatedGeneralData,
    });
    setIsGeneralExaminationBtn(false);
  };

  return (
    <div
      className="patient-info basic-patient-info"
      style={{ height: '452px', overflowY: 'auto' }}
    >
      <Row>
        <Col xs={12} sm={12} md={6} className="">
          <Form.Group className="mb-2">
            <Form.Label className="label-bold">Phone No. </Form.Label>
            <AsyncTypeahead
              labelKey="phoneNumber"
              ref={typeaheadRef}
              filterBy={filterBy}
              id="async-example"
              size="sm"
              isLoading={isLoading}
              options={searchResultArr}
              {...(isEdit
                ? {
                    selected: [
                      searchResultArr?.length > 0
                        ? searchResultArr[0]
                        : { id: '', phoneNumber: '' },
                    ],
                  }
                : {})}
              placeholder={phoneNumber ? phoneNumber : 'Add/Search by Phone No'}
              onChange={selectOption}
              minLength={5}
              onSearch={handleOnInputChange}
              //className="form-control-sm"
              renderMenuItemChildren={(option, props) => (
                <Fragment>
                  <span>{`${option?.phoneNumber} (${option.name})`}</span>
                </Fragment>
              )}
            />
            <small className="v-error">{getErrorMessage('phoneNumber')}</small>
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Form.Group>
            <Form.Label className="d-block label-custom label-bold">
              <span>Name</span>
              <ButtonGroup
                className="appointment-btn-group mb-1"
                aria-label="Patient type selection"
              >
                <Button
                  size="sm"
                  variant={
                    patientType === 'new' ? 'primary' : 'outline-secondary'
                  }
                  onClick={() => setPatientType('new')}
                >
                  New
                </Button>

                <Button
                  size="sm"
                  variant={
                    patientType === 'old' ? 'primary' : 'outline-secondary'
                  }
                  onClick={() => setPatientType('old')}
                >
                  Old
                </Button>
              </ButtonGroup>
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter name"
              size="sm"
              defaultValue={patientInfo?.name}
              onChange={(e) =>
                setPatientInfo({ ...patientInfo, name: e.target.value })
              }
            />
            <small className="v-error">{getErrorMessage('name')}</small>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="mb-2">
            <Form.Label
              style={{
                display: 'block',
                marginTop: '3px',
                color: 'black',
              }}
            >
              <span>Age</span>
              <ButtonGroup
                className="appointment-btn-group"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={!ageOrDob ? 'primary' : 'outline-secondary'}
                  onClick={() => handleType(false)}
                >
                  Age
                </Button>
                <Button
                  size="sm"
                  variant={ageOrDob ? 'primary' : 'outline-secondary'}
                  onClick={() => handleType(true)}
                >
                  DOB
                </Button>
              </ButtonGroup>
            </Form.Label>
            {!ageOrDob && (
              <InputGroup>
                <Form.Control
                  type="number"
                  defaultValue={dob?.years}
                  className="form-control-sm"
                  placeholder="Year"
                  onChange={(e) => handleAge('years', e.target.value)}
                />
                <Form.Control
                  type="number"
                  defaultValue={dob?.months}
                  placeholder="Month"
                  className="form-control-sm"
                  onChange={(e) => handleAge('months', e.target.value)}
                />
                <Form.Control
                  type="number"
                  defaultValue={dob?.days}
                  placeholder="Day"
                  className="form-control-sm"
                  onChange={(e) => handleAge('days', e.target.value)}
                />
              </InputGroup>
            )}
            {ageOrDob && (
              <Form.Control
                type="date"
                placeholder="Enter age"
                value={birthDate}
                className="form-control-sm"
                // data-date-format="DD MMMM YYYY"
                onChange={
                  (e) => handleAge('dob', e.target.value)
                  // setBirthDate(e.target.value)
                }
              />
            )}
            <small className="v-error">{getErrorMessage('birthDate')}</small>
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={4}>
          <Form.Group className="mb-0">
            <Form.Label className="label-bold">Gender</Form.Label>
            <div
              className="appointment-gender-buttons pb-2"
              aria-label="Gender"
            >
              <Button
                size="sm"
                className="btn-compact"
                variant={
                  patientInfo?.gender === 'male'
                    ? 'primary'
                    : 'outline-secondary'
                }
                onClick={() =>
                  setPatientInfo({ ...patientInfo, gender: 'male' })
                }
              >
                Male
              </Button>
              <Button
                size="sm"
                className="btn-compact ml-2"
                variant={
                  patientInfo?.gender === 'female'
                    ? 'primary'
                    : 'outline-secondary'
                }
                onClick={() =>
                  setPatientInfo({ ...patientInfo, gender: 'female' })
                }
              >
                Female
              </Button>
              <Button
                size="sm"
                className="btn-compact ml-2"
                variant={
                  patientInfo?.gender === 'others'
                    ? 'primary'
                    : 'outline-secondary'
                }
                onClick={() =>
                  setPatientInfo({ ...patientInfo, gender: 'others' })
                }
              >
                Others
              </Button>
            </div>
            <small className="v-error">{getErrorMessage('gender')}</small>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col xs={12} sm={12} md={6}>
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Height</span>
              <ButtonGroup
                className="patient-info-btn-group mb-1"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.heightInfo?.heightUnit === 'Ft'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('heightUnit', 'Ft')}
                >
                  Ft
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.heightInfo?.heightUnit === 'Cm'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('heightUnit', 'Cm')}
                >
                  Cm
                </Button>
              </ButtonGroup>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              {generalExaminations?.heightInfo?.heightUnit === 'Ft' && (
                <>
                  <Form.Control
                    className="mr-3"
                    size="sm"
                    type="number"
                    placeholder="Enter Feet"
                    defaultValue={generalExaminations?.heightInfo?.feet}
                    value={generalExaminations?.heightInfo?.feet}
                    onClick={() => handleBtnInputArray('feet')}
                    onChange={(e) => handleInput('feet', e.target.value)}
                  />
                  <Form.Control
                    size="sm"
                    type="number"
                    defaultValue={generalExaminations?.heightInfo?.inch}
                    value={generalExaminations?.heightInfo?.inch}
                    placeholder="Inch"
                    onClick={() => handleBtnInputArray('inch')}
                    onChange={(e) => handleInput('inch', e.target.value)}
                  />
                </>
              )}
              {generalExaminations?.heightInfo?.heightUnit === 'Cm' && (
                <>
                  <Form.Control
                    className="mr-3"
                    size="sm"
                    type="number"
                    placeholder="Enter CM"
                    defaultValue={generalExaminations?.heightInfo?.feet}
                    value={generalExaminations?.heightInfo?.feet}
                    onClick={() => handleBtnInputArray('feet')}
                    onChange={(e) => handleInput('feet', e.target.value)}
                  />
                </>
              )}
            </div>
          </Form.Group>
          {isGeneralExaminationBtn &&
            (fieldName === 'feet' || fieldName === 'inch') && (
              <Row>
                <Col md={fieldName === 'feet' ? -1 : 0}></Col>
                <Col md={fieldName === 'feet' ? 0 : 9}>
                  <GeneralExaminationBtn
                    fieldName={fieldName}
                    btnInputArray={btnInputArray}
                    onClickAction={handleInput}
                  />
                </Col>
              </Row>
            )}
        </Col>
        <Col xs={12} sm={12} md={6} className="">
          <Form.Group>
            <Form.Label className="d-block label-bold weight-responsive">
              <span>Weight</span>
              <ButtonGroup
                className="patient-info-btn-group"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.weightInfo?.weightUnit === 'KG'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('weightUnit', 'KG')}
                >
                  KG
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.weightInfo?.weightUnit === 'Pound'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('weightUnit', 'Pound')}
                >
                  Pound
                </Button>
              </ButtonGroup>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              <Form.Control
                className="form-control-sm"
                type="text"
                value={generalExaminations?.weightInfo?.weight}
                defaultValue={generalExaminations?.weightInfo?.weight}
                placeholder="Weight"
                onChange={(e) => handleInput('weight', e.target.value)}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} sm={12} md={6}>
          <Form.Group>
            <Form.Label className=" d-block d-flex justify-content-space-between label-bold">
              <span>Blood Pressure</span>
              <span style={{ paddingLeft: '65px' }}>mm HG</span>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              <Form.Control
                className="mr-2"
                size="sm"
                type="number"
                placeholder="Systolic"
                defaultValue={generalExaminations?.bloodPressure?.systolic}
                value={generalExaminations?.bloodPressure?.systolic}
                onClick={() => handleBtnInputArray('systolic')}
                onChange={(e) => handleInput('systolic', e.target.value)}
              />
              <div style={{ fontSize: '21px' }}>/</div>
              <Form.Control
                className="ml-2"
                size="sm"
                type="number"
                placeholder="Diastolic"
                defaultValue={generalExaminations?.bloodPressure?.diastolic}
                value={generalExaminations?.bloodPressure?.diastolic}
                onClick={() => handleBtnInputArray('diastolic')}
                onChange={(e) => handleInput('diastolic', e.target.value)}
              />
            </div>
          </Form.Group>
          {isGeneralExaminationBtn &&
            (fieldName === 'systolic' || fieldName === 'diastolic') && (
              <Row>
                <Col md={12}>
                  <GeneralExaminationBtn
                    fieldName={fieldName}
                    btnInputArray={btnInputArray}
                    onClickAction={handleInput}
                  />
                </Col>
              </Row>
            )}
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Pulse</span>
              <ButtonGroup
                className="patient-info-btn-group mb-1"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.pulseInfo?.pulseUnit === 'PM'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('pulseUnit', 'PM')}
                >
                  PM
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.pulseInfo?.pulseUnit === 'BPM'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('pulseUnit', 'BPM')}
                >
                  BPM
                </Button>
              </ButtonGroup>
            </Form.Label>
            <Row>
              <Col className="pulse-btns">
                <Form.Control
                  style={{ width: '5rem' }}
                  size="sm"
                  type="number"
                  placeholder="Pulse"
                  defaultValue={generalExaminations?.pulseInfo?.pulse}
                  onClick={() => handleBtnInputArray('pulse')}
                  onChange={(e) => handleInput('pulse', e.target.value)}
                />
                <Button
                  className="ml-2"
                  size="sm"
                  variant={
                    generalExaminations?.pulseInfo?.pulseType === 'Regular'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={(e) => handleInput('pulseType', 'Regular')}
                >
                  Regular
                </Button>
                <Button
                  className=""
                  size="sm"
                  variant={
                    generalExaminations?.pulseInfo?.pulseType === 'Irregular'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={(e) => handleInput('pulseType', 'Irregular')}
                >
                  Irregular
                </Button>
                <Button
                  size="sm"
                  style={{ whiteSpace: 'nowrap' }}
                  variant={
                    generalExaminations?.pulseInfo?.pulseType === 'Drop Beat'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={(e) => handleInput('pulseType', 'Drop Beat')}
                >
                  Drop Beat
                </Button>
                {/* </div> */}
              </Col>
            </Row>
          </Form.Group>
          {isGeneralExaminationBtn && fieldName === 'pulse' && (
            <Row>
              <Col xs={12} sm={12} md={12}>
                <GeneralExaminationBtn
                  fieldName={fieldName}
                  btnInputArray={btnInputArray}
                  onClickAction={handleInput}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="label-custom label-bold">Email</Form.Label>
            <Form.Control
              size="sm"
              type="email"
              placeholder="Enter email"
              defaultValue={patientInfo?.email}
              onChange={(e) =>
                setPatientInfo({ ...patientInfo, email: e.target.value })
              }
            />
            <small className="v-error">{getErrorMessage('email')}</small>
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="label-custom label-bold">Address</Form.Label>
            <Form.Control
              size="sm"
              type="text"
              placeholder="Enter address"
              defaultValue={patientInfo?.patientDetails?.address}
              onChange={(e) =>
                setPatientInfo({
                  ...patientInfo,
                  patientDetails: {
                    ...patientInfo.patientDetails,
                    address: e.target.value,
                  },
                })
              }
            />
            <small className="v-error">{getErrorMessage('address')}</small>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="label-bold label-custom">
              Appointment Date
            </Form.Label>
            <Form.Control
              type="datetime-local"
              size="sm"
              defaultValue={appointmentSchedule}
              // defaultValue={
              //   appointmentInfo.appointmentDateTime
              //     ? moment
              //         .utc(appointmentInfo.appointmentDateTime)
              //         .local()
              //         .format('YYYY-MM-DD HH:mm')
              //     : moment().format('YYYY-MM-DD HH:mm')
              // }
              onChange={(e) =>
                setAppointmentDateTime(
                  moment(e.target.value).format('YYYY-MM-DD HH:mm'),
                )
              }
            />
            <small className="v-error">
              {getErrorMessage('appointmentDateTime')}
            </small>
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="d-block label-custom label-bold">
              <span>Visitation Fee</span>
              <ButtonGroup
                className="appointment-btn-group mb-1"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    visitType === 'new' ? 'primary' : 'outline-secondary'
                  }
                  onClick={() => {
                    setVisitType('new');
                  }}
                >
                  New
                </Button>
                <Button
                  size="sm"
                  variant={
                    visitType === 'followup' ? 'primary' : 'outline-secondary'
                  }
                  onClick={() => {
                    setVisitType('followup');
                  }}
                >
                  Follow up
                </Button>
                <Button
                  size="sm"
                  variant={
                    visitType === 'report' ? 'primary' : 'outline-secondary'
                  }
                  onClick={() => {
                    setVisitType('report');
                  }}
                >
                  Report
                </Button>
              </ButtonGroup>
            </Form.Label>
            <Form.Control
              size="sm"
              type="number"
              placeholder="Enter visitation fee"
              defaultValue={
                appointmentInfo?.paymentDetails?.amount
                  ? appointmentInfo?.paymentDetails?.amount
                  : ''
              }
              onChange={(e) => {
                setVisitationFee(e.target.value);
              }}
            />
            <small className="v-error">
              {getErrorMessage('visitationFee')}
            </small>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="">
            <Form.Label className="label-custom label-bold">
              Serial Number
            </Form.Label>
            <Form.Control
              size="sm"
              type="number"
              defaultValue={
                appointmentInfo?.serialNumber
                  ? appointmentInfo?.serialNumber
                  : ''
              }
              onChange={(e) =>
                setPatientInfo({
                  ...patientInfo,
                  serialNumber: e.target.value,
                })
              }
            />
            <small className="v-error">{getErrorMessage('serialNumber')}</small>
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Form.Group className="">
            <Form.Label className="label-custom label-bold">
              Presenting Complain{' '}
            </Form.Label>
            <SearchAreaAsyncAppointment
              modalTitle={''}
              closeAction={setCloseFunction}
              setSearchOptions={setChiefComplainsInSearch}
              handleOnInputChange={handleOnInputChangeChiefComplain}
              handleSearchOrNew={handleSearchOrNew}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              options={chiefComplainsInSearch}
              selectedInputs={selectedChiefComplains}
              placeholder={'chief complain'}
            />
            <span
              style={{ fontSize: 'small', color: '#7a7777', marginLeft: '8px' }}
            >
              {selectedChiefComplains?.map((item) => item.name)?.join(', ')}
            </span>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default memo(BasicPatientForAppointment);
